import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { cloneDeep, parseInt } from 'lodash';
import { KwikKeyConfigType, ProductConfigStep, V6ProductType } from '../../../../../../core/enums';
import { Bp1configurationRequest, BuildPakAttribute, IBp1configurationRequest, IBuildPakAttribute, IProductTemplateError, V6NestedFrame, V6outerFrameBp1 } from '../../../../../../core/models';
import { CommonService } from '../../../../../../core/services/common.service';
import { UserService } from '../../../../../../core/services/user.service';
import { V6macroService } from '../../../../../../core/services/v6macro.service';
import { V6productService } from '../../../../../../core/services/v6product.service';
import { V6translationService } from '../../../../../../core/services/v6translation.service';
import { createDummy, KK190_Create, std_1dr_do } from '../../create-configuration/moctData';

@Component({
  selector: 'app-bp1',
  templateUrl: './bp1.component.html',
  styleUrls: ['./bp1.component.scss']
})
export class Bp1Component implements OnInit {

  @Output() outputResponse = new EventEmitter<any>();

  configCreationInProgres: boolean;
  createConfigurationRequest: IBp1configurationRequest = new Bp1configurationRequest();
  productInitializing: boolean = true;
  prdmError: IProductTemplateError;
  isFormSubmiited: boolean = false;
  configError: string = '';

  //update product model and add error props in every attribute
  //if any of them has error then show the error in respective section plus highlight the control as well

  constructor(private v6productService: V6productService,
    private v6translationService: V6translationService,
    private commonService: CommonService,
    private v6MacroService: V6macroService,
    private userService: UserService,
    private router: Router) { }

  get productModel() {
    return this.v6productService.bp1PreviewModel;
  }
  set productModel(pm) {
    this.v6productService.bp1PreviewModel = pm;
  }
  get isInAdmin() {
    return this.v6productService.isInAdminSection;
  }

  isCopySettingsAvailable: boolean = true;
  ngOnInit() {
    this.initErrorModel();
    this.v6MacroService.attachMacroHelperFunctions(this.productModel);
    this.v6MacroService.runMacros('pageLoad', this.productModel.bp1Macros, this.productModel);
    this.productModel.nestedFrames.forEach((el, index) => {
      this.productModel.nestedFrames[index].attributeFiltersForUI.push(this.productModel.nestedFrames[index].attributeFilters);//this.v6productService.organizeControlsInTabluarForm(this.productModel.nestedFrames[index].attributeFilters);
    })
    this.productModel.resourceFrame.attributeFiltersForUI.push(this.productModel.resourceFrame.attributeFilters);//this.v6productService.organizeControlsInTabluarForm(this.productModel.resourceFrame.attributeFilters);

    var url = this.router.url;
    if (url.includes("configProduct/createConfiguration")) {
      this.v6productService.isInAdminSection = true;
    }
    else {
      this.v6productService.isInAdminSection = false;
    }

    console.log(this.productModel);
  }

  initProductModel() { }
  initKKitem() {
    //nope----
    //const eFin = this.productModel.productAttributes.find(x => x.v6ReferenceCode === 'Job/Exterior Finish');
    //if (eFin) { eFin.show=false;}
  }

  executeMacro(attrs: IBuildPakAttribute) {
    if (attrs.value) { attrs.isError = false; attrs.errorMessage = '' };
    const element = attrs;
    if (element) {
      element.isDirty = true;
      //if list r radio button
      if (element.value) element.code = element.options.find(x => x.value === element.value).code;
    }
    this.v6MacroService.attachMacroHelperFunctions(this.productModel);
    let nameMacros: any = [];
    if (this.productModel.configNameExpression) {
      nameMacros.push(this.productModel.configNameExpression);
    }
    this.v6MacroService.runMacros('onChange', this.productModel.bp1Macros, this.productModel);
    if (this.productModel.configNameExpression) {
      this.v6MacroService.runMacros('computeName', nameMacros, this.productModel);
    }
    this.v6productService.buildResourceFrameCode(this.productModel.resourceFrame);
    this.productModel.nestedFrames.forEach((el, index) => {
      this.v6productService.buildNestedFrameCode(el);
    });

    if (this.isFormSubmiited) {
      this.validateBP1();
    }
  }

  submitConfiguration(onlyUpdate: boolean) {
    this.isFormSubmiited = true;
    this.v6MacroService.runMacros('validate', this.productModel.bp1Macros, this.productModel);
    if (!this.validateBP1()) return;//commented for test
    //if there is no error then proceed
    if (this.productModel.type === V6ProductType.CONFIGURED) {
      this.createConfiguration();
    }
    else {
      this.createKwikKeyConfiguration();
    }
  }

  createConfiguration() {
    this.configError = '';
    this.configCreationInProgres = true;
    this.createConfigurationRequest = new Bp1configurationRequest();
    this.createConfigurationRequest.customerCode = this.userService.readUserObject.customerNumber.toString();// '3031';//get current cust no from user service 
    //create bp1 as data provided by user
    this.createConfigurationRequest.reference = this.productModel.reference;
    const q = parseInt(this.productModel.quantity ? this.productModel.quantity.toString() : "1");
    this.createConfigurationRequest.quantity = q;
    this.createConfigurationRequest.defaultOptions = [];
    this.createConfigurationRequest.outerFrame = new V6outerFrameBp1();
    const ppFin = this.productModel.productAttributes.find(x => x.publishedName === 'Push/Pull Finish');
    const jobFin = this.productModel.productAttributes.find(x => x.publishedName === 'Exterior Finish');
    //if (jobFin && ppFin) {
    //  ppFin.value = jobFin.options[0].value;
    //  ppFin.code = jobFin.options[0].code;
    //}
    this.productModel.productAttributes.forEach((el, index) => {
      if (el.show) {
        let option = { code: this.v6translationService.translateKDToV6(el.name, el.v6ReferenceCode), value: el.value }
        this.createConfigurationRequest.defaultOptions.push(option);
      }
    });
    //some default options in product attributes
    //this.createConfigurationRequest.defaultOptions.push({ code: "Job/Exterior Finish", value: '[COL: K: 14(14)]' });
    //this.createConfigurationRequest.defaultOptions.push({ code: "Hardware Finish", value: '[COL:K:17 (17)]' });   
    this.createConfigurationRequest.defaultOptions.push({ code: "Interior Finish", value: jobFin.value });
    this.createConfigurationRequest.defaultOptions.push({ code: "Billing Finish", value: jobFin.value });
    if (ppFin) {
      this.createConfigurationRequest.defaultOptions.push({ code: 'PushPull Finish', value: jobFin.value });
    }

    this.productModel.nestedFrames.forEach((el, index) => {
      let option = { code: this.commonService.convertIntToString(index + 1) + ' Door Opening', value: el.frameConfig }
      //for test only copy 1st door details
      //if (index > 0) {
      //  option = { code: this.commonService.convertIntToString(index + 1) + ' Door Opening', value: this.productModel.nestedFrames[0].frameConfig }
      //}
      this.createConfigurationRequest.defaultOptions.push(option);
    });
    let t = this.productModel.nestedFrames.length
    this.createConfigurationRequest.outerFrame.frameCode = this.productModel.resourceFrame.frameConfig;
    if (t === 1) {
      this.createConfigurationRequest.originalDescription = this.productModel.computedName;
    }
    else {
      this.createConfigurationRequest.originalDescription = this.productModel.productName;
    }

    if (!this.createConfigurationRequest.originalDescription) { this.createConfigurationRequest.originalDescription = this.productModel.productName; }

    const frmtype = this.productModel.resourceFrame.attributeFilters.find(x => x.publishedName === 'Frame System');
    if (frmtype) {
      this.createConfigurationRequest.outerFrame.frameOptions = [{ code: this.v6translationService.translateKDToV6(frmtype.name, frmtype.v6ReferenceCode), value: frmtype.value }];
    }
    else {
      //for 2000T
      this.createConfigurationRequest.outerFrame.frameOptions = []
      this.productModel.resourceFrame.attributeFilters.forEach((el, index) => {
        this.createConfigurationRequest.outerFrame.frameOptions.push({ code: this.v6translationService.translateKDToV6(el.name, el.v6ReferenceCode), value: el.value })
      })
    }
    this.productModel.nestedFrames.forEach((el, index) => {
      let nFrame = {
        frameCode: el.frameConfig,
        frameOptions: []
      };
      let attrs = el.attributeFilters;
      attrs.forEach((attr, attrIndx) => {
        nFrame.frameOptions.push({ code: this.v6translationService.translateKDToV6(attr.name, attr.v6ReferenceCode), value: attr.value ? attr.value : '' })
      });
      //if (index > 0) {//testing purpose copy door 1 values
      //  nFrame.frameCode = this.productModel.nestedFrames[0].frameConfig;
      //  nFrame.frameOptions = this.createConfigurationRequest.outerFrame.nestedFrames[0].frameOptions;
      //}
      this.createConfigurationRequest.outerFrame.nestedFrames.push(nFrame);
    });

    console.log('bp1 config request');
    console.log(this.createConfigurationRequest);
    //this.test();
    //return;
    this.productModel.erros = [];
    const start = new Date().getTime()
    this.v6productService.createConfigurationX(this.createConfigurationRequest).subscribe(resp => {

      if (resp) {
        this.productModel.quoteCommonId = resp.configuration.quoteCommonId;
        this.productModel.quoteItemCommonId = resp.configuration.quoteItemCommonId;
        if (this.v6productService.hasError(resp)) {
          let destination = this.v6productService.bp1PreviewModel;
          this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
          this.outputToParent(resp.configuration.quoteItemCommonId);
          if (resp.messages && resp.messages.length > 0) {
            resp.messages.forEach((el, i) => {
              if (el.type && el.type === 2) { this.productModel.erros.push(el.value); }
            });
          }
          this.productModel.v6SummaryMessage = [];
        }
        else {
          this.v6productService.curResponse = resp;
          this.v6productService.bp2PreviewModel = cloneDeep(this.v6productService.bp1PreviewModel);
          let destination = this.v6productService.bp2PreviewModel;
          this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
          this.outputToParent(resp.configuration.quoteItemCommonId);
          //add ppfin to nested frame
          //this.repositionPPFinIfApplicable(destination);
          this.v6productService.currentProductConfigStep = ProductConfigStep.CONFIG_DETAILS;
        }
      }
      else {
        //something happend
        this.configError = 'Sorry an error occured. Please try again. If error persists then please contact Kawneer Helpdesk';
      }
      this.configCreationInProgres = false;
    });

  }
  createKwikKeyConfiguration_orig() {
    this.configCreationInProgres = true;
    this.configError = '';
    //run BP1 vaidate macros
    this.createConfigurationRequest = new Bp1configurationRequest();
    this.createConfigurationRequest.customerCode = this.userService.readUserObject.customerNumber.toString();//'3031';//get current cust no from user service 

    //fill default value in bp1 request
    this.createConfigurationRequest.reference = this.productModel.reference;
    const q = parseInt(this.productModel.quantity ? this.productModel.quantity.toString() : "1");
    this.createConfigurationRequest.quantity = q;
    this.createConfigurationRequest.defaultOptions = [];
    this.createConfigurationRequest.outerFrame = new V6outerFrameBp1();
    this.createConfigurationRequest.defaultOptions.push({ code: "EFINISH1", value: this.productModel.kwikKeyV6Finish });//from the product itself
    const hdFin = this.productModel.productAttributes.find(x => x.publishedName === 'Hardware Finish');
    this.createConfigurationRequest.defaultOptions.push({ code: "CFINISH2", value: hdFin.value });//selected hardware finish

    //add tr or not based on selection

    let crossRailsAttr = null;
    let transomAttr = null;
    if (this.productModel.type === V6ProductType.KWIK_KEY_DOOR) {
      let defFrameCode = "[FRA:A1:" + this.productModel.kwikKeyProductSeries + this.productModel.kwikKeyOptionCode.replace(/[0-9]/g, '');
      crossRailsAttr = this.productModel.productAttributes.find(x => x.name === 'Kwikkey_CrossRails');
      transomAttr = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Transom');
      const frmtype = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Kwikkey_FrameSeries');
      if (crossRailsAttr) {
        defFrameCode = defFrameCode + crossRailsAttr.code;
      }
      this.createConfigurationRequest.defaultOptions.push({ code: "FRAME1", value: defFrameCode + "]" });
      let frmCode = '00';
      let outerFrCode = "[FRA:A1:450" + this.productModel.kwikKeyOptionCode;
      if (this.productModel.kkConfigType === KwikKeyConfigType.DOOR_ONLY) {
        frmCode = '00';
        outerFrCode = "[FRA:A2:DO36";
      }
      else {
        if (frmtype.value) {
          frmCode = frmtype.options.find(x => x.value === frmtype.value).code;
        }
        if (transomAttr) {
          outerFrCode = outerFrCode + (transomAttr.code || '');
        }
      }
      this.createConfigurationRequest.outerFrame.frameOptions = [{ code: 'Frame Type', value: frmCode }];
      this.createConfigurationRequest.outerFrame.frameCode = outerFrCode + "]";
    }
    else {
      let defFrameCode = "[FRA:A1:" + this.productModel.kwikKeyProductSeries + this.productModel.kwikKeyOptionCode;
      crossRailsAttr = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Kwikkey_CrossRails');
      transomAttr = this.productModel.productAttributes.find(x => x.name === 'Transom');
      const doorTypeAttr = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Kwikkey_DoorType');
      this.createConfigurationRequest.outerFrame.nestedFrames = [];
      this.createConfigurationRequest.outerFrame.nestedFrames.push(new V6NestedFrame());
      if (transomAttr) { defFrameCode = defFrameCode + (transomAttr.code || ''); }
      defFrameCode = defFrameCode + "]";
      this.createConfigurationRequest.outerFrame.frameCode = defFrameCode;

      if (this.productModel.kkConfigType == KwikKeyConfigType.FRAME_ONLY) {
        this.createConfigurationRequest.outerFrame.nestedFrames[0].frameOptions.push({ code: "DrType", value: "01BPES" });
        this.createConfigurationRequest.outerFrame.nestedFrames[0].frameCode = "[FRA:A2:BPE-FO-SNGL]";
        this.createConfigurationRequest.defaultOptions.push({ code: "1st Door Opening", value: "[FRA:A2:BPE-FO-SNGL]" });
      }
      else {
        let nestedFrCode = "[FRA:A1:190" + this.productModel.kwikKeyOptionCode.replace(/[0-9]/g, '');
        if (crossRailsAttr) {
          nestedFrCode = nestedFrCode + crossRailsAttr.code;
        }
        nestedFrCode = nestedFrCode + "]";
        this.createConfigurationRequest.outerFrame.nestedFrames[0].frameCode = nestedFrCode;
        this.createConfigurationRequest.defaultOptions.push({ code: "1st Door Opening", value: nestedFrCode });
      }
    }
    this.createConfigurationRequest.originalDescription = 'KWIKKEY ' + this.productModel.productCode;
    console.log('create config request');
    console.log(this.createConfigurationRequest);
    console.log(JSON.stringify(this.createConfigurationRequest));
    //this.test();
    //return;
    this.v6productService.createConfigurationX(this.createConfigurationRequest).subscribe(resp => {
      if (resp) {
        this.productModel.quoteCommonId = resp.configuration.quoteCommonId;
        this.productModel.quoteItemCommonId = resp.configuration.quoteItemCommonId;
        if (this.v6productService.hasError(resp)) {
          let destination = this.v6productService.bp1PreviewModel;
          this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
          this.outputToParent(resp.configuration.quoteItemCommonId);
          if (resp.messages && resp.messages.length > 0) {
            resp.messages.forEach((el, i) => {
              if (el.type && el.type === 2) { this.productModel.erros.push(el.value); }
            });
          }
          this.productModel.v6SummaryMessage = [];
        }
        else {
          this.v6productService.bp2PreviewModel = cloneDeep(this.v6productService.bp1PreviewModel);
          let destination = this.v6productService.bp2PreviewModel;
          this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
          this.outputToParent(resp.configuration.quoteItemCommonId);
          //add ppfin to nested frame
          //this.repositionPPFinIfApplicable(destination);
          this.v6productService.currentProductConfigStep = ProductConfigStep.CONFIG_DETAILS;
        }
      }
      else {
        //something happend
        this.configError = 'Sorry an error occured. Please try again. If error persists then please contact Kawneer Helpdesk';
      }
      this.configCreationInProgres = false;
    });

  }


async createKwikKeyConfiguration() {
    this.configCreationInProgres = true;//test comment
    this.configError = '';
    //run BP1 vaidate macros
    this.createConfigurationRequest = this.v6productService.getBasicKKConfig();
    this.createConfigurationRequest.customerCode = this.userService.readUserObject.customerNumber.toString();
    this.createConfigurationRequest.reference = this.productModel.reference;
    const q = parseInt(this.productModel.quantity ? this.productModel.quantity.toString() : "1");
    this.createConfigurationRequest.quantity = q;
    const hdFinField = this.productModel.productAttributes.find(x => x.publishedName === 'Hardware Finish');
    let crossRailsAttr = null;
    let transomAttr = null;
    let setupDetails = this.v6productService.findKKSetupDetails(this.productModel.productCode);


    if (this.productModel.type === V6ProductType.KWIK_KEY_DOOR) {
      //find door code
      crossRailsAttr = this.productModel.productAttributes.find(x => x.name === 'Cross Rails');
      let crossRailVal = '';
      if (crossRailsAttr) {
        crossRailVal = crossRailsAttr.code;
      }
      let matchinDoorCodeFromProductDtls = '190' + this.productModel.kwikKeyOptionCode.replace(/[0-9]/g, '');
      let matchinDoorCodeFinal = '[FRA:A1:' + this.v6productService.findMatchingKKDoorCode(matchinDoorCodeFromProductDtls, crossRailVal) + ']';

      //find outer frame code
      transomAttr = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Transom');
      let transomVal = '';
      if (transomAttr) {
        transomVal = transomAttr.code || '';
      }
      let outerFrameCodeFromProductDtls = "450" + this.productModel.kwikKeyOptionCode;
      let outerFrameCodeFinal = '[FRA:A1:' + this.v6productService.findMatchingKKFrameCode(outerFrameCodeFromProductDtls, transomVal) + ']';
      this.v6productService.setKKDefaultOptions(this.createConfigurationRequest, hdFinField.value, this.productModel.kwikKeyV6Finish, matchinDoorCodeFinal);
      const frmType = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Kwikkey_FrameSeries');
      let frmCode = '00';
      if (this.productModel.kkConfigType === KwikKeyConfigType.DOOR_ONLY) {
        this.v6productService.setKKOuterFrameOptions(this.createConfigurationRequest, '00', "[FRA:A2:DO36]");
        this.v6productService.setKKNestedFrame(this.createConfigurationRequest, setupDetails, matchinDoorCodeFinal);//might need to check in test suite
      }
      else {
        if (frmType.value) {
          frmCode = frmType.options.find(x => x.value === frmType.value).code;
        }
        this.v6productService.setKKOuterFrameOptions(this.createConfigurationRequest, frmCode, outerFrameCodeFinal);
        this.v6productService.setKKNestedFrame(this.createConfigurationRequest, setupDetails, matchinDoorCodeFinal);
        if (frmType.value === '540' || frmType.value === '550' || frmType.value === '551') {
          this.createConfigurationRequest.outerFrame.frameOptions.push({ code: 'Tubular', value: "False" });
        }
      }
    }
    else {

      //find door code
      crossRailsAttr = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Cross Rails');
      let crossRailVal = '';
      if (crossRailsAttr) {
        crossRailVal = crossRailsAttr.code;
      }
      let j = this.productModel.kwikKeyOptionCode;
      if (j.endsWith('TR')) {
        j = j.replace('TR', '');
      }
      j = j.replace(/[0-9]/g, '');
      let matchinDoorCodeFromProductDtls = '190' + j;// this.productModel.kwikKeyOptionCode.replace(/[0-9]/g, '');
      let matchinDoorCodeFinal = '[FRA:A1:' + this.v6productService.findMatchingKKDoorCode(matchinDoorCodeFromProductDtls, crossRailVal) + ']';

      //find outer frame code
      transomAttr = this.productModel.productAttributes.find(x => x.name === 'Transom');
      let transomVal = '';
      if (transomAttr) {
        transomVal = transomAttr.code || '';
      }


      let outerFrameCodeFromProductDtls = "450" + this.productModel.kwikKeyOptionCode;
      let outerFrameCodeFinal = '[FRA:A1:' + this.v6productService.findMatchingKKFrameCode(outerFrameCodeFromProductDtls, transomVal) + ']';

      this.v6productService.setKKDefaultOptions(this.createConfigurationRequest, hdFinField.value, this.productModel.kwikKeyV6Finish, matchinDoorCodeFinal);
      //set door frame
      const doorTypeAttr = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Kwikkey_DoorType');
      if (this.productModel.kkConfigType == KwikKeyConfigType.FRAME_ONLY) {
        //k50-1037 Sanjeev start work
        // this.createConfigurationRequest.outerFrame.nestedFrames[0].frameOptions.push({ code: "DrType", value: "01BPES" });

        if (this.productModel.kwikKeyOptionCode.indexOf('P') === 0) {
          //pick template for pair door
          setupDetails.DrType = "01BPEP";
          this.createConfigurationRequest.outerFrame.nestedFrames[0].frameCode = "[FRA:A2:BPE-FO-PR]";
          let doorOption = this.createConfigurationRequest.defaultOptions.find(x => x.code === "1st Door Opening");
          doorOption.value = "[FRA:A2:BPE-FO-PR]";
        }
        else {
          //pick template for single door
          setupDetails.DrType = "01BPES";
          this.createConfigurationRequest.outerFrame.nestedFrames[0].frameCode = "[FRA:A2:BPE-FO-SNGL]";
          let doorOption = this.createConfigurationRequest.defaultOptions.find(x => x.code === "1st Door Opening");
          doorOption.value = "[FRA:A2:BPE-FO-SNGL]";
        }


        const kwikkeyresponse = await this.v6productService.getKwikKeyConfiguration(this.productModel.productCode);
        if (kwikkeyresponse && kwikkeyresponse.length > 0) {
          setupDetails.Hinge = kwikkeyresponse[0].hinge;
          setupDetails.Lock = kwikkeyresponse[0].lock;
          setupDetails.Hand = kwikkeyresponse[0].hand;
          setupDetails.FrameType = kwikkeyresponse[0].frameType;
        }
        //setupDetails.DrType = "01BPES";
        //this.createConfigurationRequest.outerFrame.nestedFrames[0].frameCode = "[FRA:A2:BPE-FO-SNGL]";
        this.v6productService.setKKNestedFrame(this.createConfigurationRequest, setupDetails, this.createConfigurationRequest.outerFrame.nestedFrames[0].frameCode, true);
        //k50-1037 Sanjeev end work
      
        this.v6productService.setKKOuterFrameOptions(this.createConfigurationRequest, this.v6productService.tempPadZeroIfNeeded(setupDetails.FrameType).toString(), outerFrameCodeFinal)
      }
      else {
        this.v6productService.setKKOuterFrameOptions(this.createConfigurationRequest, this.v6productService.tempPadZeroIfNeeded(setupDetails.FrameType).toString(), outerFrameCodeFinal);
        setupDetails.DrType = doorTypeAttr.value
        this.v6productService.setKKNestedFrame(this.createConfigurationRequest, setupDetails, matchinDoorCodeFinal);
      }


      if (this.productModel.productCode.indexOf('540-') > -1
        || this.productModel.productCode.indexOf('550-') > -1
        || this.productModel.productCode.indexOf('551-') > -1) {
        this.createConfigurationRequest.outerFrame.frameOptions.push({ code: 'Tubular', value: "False" });
      }

    }
    this.createConfigurationRequest.originalDescription = 'KWIKKEY ' + this.productModel.productCode;
    console.log('create config request');
    console.log(this.createConfigurationRequest);
    console.log(JSON.stringify(this.createConfigurationRequest));
    //this.test();
    //return;
    this.v6productService.createConfigurationX(this.createConfigurationRequest).subscribe(resp => {
      if (resp) {
        this.productModel.quoteCommonId = resp.configuration.quoteCommonId;
        this.productModel.quoteItemCommonId = resp.configuration.quoteItemCommonId;
        if (this.v6productService.hasError(resp)) {
          let destination = this.v6productService.bp1PreviewModel;
          this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
          this.outputToParent(resp.configuration.quoteItemCommonId);
          if (resp.messages && resp.messages.length > 0) {
            resp.messages.forEach((el, i) => {
              if (el.type && el.type === 2) { this.productModel.erros.push(el.value); }
            });
          }
          this.productModel.v6SummaryMessage = [];
        }
        else {
          this.v6productService.curResponse = resp;
          this.v6productService.bp2PreviewModel = cloneDeep(this.v6productService.bp1PreviewModel);
          let destination = this.v6productService.bp2PreviewModel;
          this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
          this.outputToParent(resp.configuration.quoteItemCommonId);
          //add ppfin to nested frame
          //this.repositionPPFinIfApplicable(destination);
          this.v6productService.currentProductConfigStep = ProductConfigStep.CONFIG_DETAILS;
        }
      }
      else {
        //something happend
        this.configError = 'Sorry an error occured. Please try again. If error persists then please contact Kawneer Helpdesk';
      }
      this.configCreationInProgres = false;
    });

  }


  //#region helper functions

  frames = [];
  public selectedCopyFromIndex: number;
  copySettings(frameIndex: number, selectedFromIndex: number) {
    if (selectedFromIndex < 0) {
      return;
    }
    let frameIdexes = [];
    console.log(this.selectedCopyFromIndex);
    this.selectedCopyFromIndex = +selectedFromIndex;//for test only
    let sf = this.productModel.nestedFrames[this.selectedCopyFromIndex];
    let destF = this.productModel.nestedFrames[frameIndex];
    destF.attributeFilters.forEach((el, i) => {
      el.value = sf.attributeFilters[i].value;//search by name instead
      el.code = sf.attributeFilters[i].code;//search by name instead
      el.isError = false; el.errorMessage = '';
    })
    this.checkModelErrors();
    this.v6productService.buildResourceFrameCode(this.productModel.resourceFrame);
    this.productModel.nestedFrames.forEach((el, index) => {
      this.v6productService.buildNestedFrameCode(el);
    });
  }
  //#endregion
  //#region validation & erros

  validateBP1(): boolean {
    let isFormValid = true;
    this.productModel.productAttributes.forEach((el, index) => {
      if (this.v6productService.isEmpty(el)) { el.isError = true; el.errorMessage = el.publishedName + " is required"; isFormValid = false; }
    });
    //if kwikey item then only product attrs are mandatory
    // if kwikey door and  frametype is selected then tr becomes mandatory
    //if kwikey frame and doortyoe is selected then other option becomes mandatory
    if (this.productModel.type === V6ProductType.KWIK_KEY_DOOR) {
      const frmtype = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Kwikkey_FrameSeries');
      if (frmtype.value) {
        this.productModel.kkConfigType = KwikKeyConfigType.DOOR_AND_FRAME;
        this.productModel.resourceFrame.attributeFilters.forEach((el, index) => {
          if (this.v6productService.isEmpty(el)) { el.isError = true; el.errorMessage = el.publishedName + " is required"; isFormValid = false; }
        });
      } else {
        this.productModel.kkConfigType = KwikKeyConfigType.DOOR_ONLY;
      }
    }
    else if (this.productModel.type === V6ProductType.KWIK_KEY_FRAME) {
      const dType = this.productModel.resourceFrame.attributeFilters.find(x => x.name === 'Kwikkey_DoorType');
      if (dType.value) {
        this.productModel.kkConfigType = KwikKeyConfigType.FRAME_AND_DOOR;
        this.productModel.resourceFrame.attributeFilters.forEach((el, index) => {
          if (this.v6productService.isEmpty(el)) { el.isError = true; el.errorMessage = el.publishedName + " is required"; isFormValid = false; }
        });
      } else {
        this.productModel.kkConfigType = KwikKeyConfigType.FRAME_ONLY;
      }
    }
    else {
      this.productModel.resourceFrame.attributeFilters.forEach((el, index) => {
        if (this.v6productService.isEmpty(el)) { el.isError = true; el.errorMessage = el.publishedName + " is required"; isFormValid = false; }
      });
      this.productModel.nestedFrames.forEach((frame, fIndex) => {
        frame.attributeFilters.forEach((el, index) => {
          if (this.v6productService.isEmpty(el)) { el.isError = true; el.errorMessage = el.publishedName + " is required"; isFormValid = false; }
        });
      });
    }
    this.checkModelErrors();
    return isFormValid;
  }
  productErrors: any[] = [];
  resourceFrameErrors: any[] = [];
  nestedFrameErrors: any[] = []
  initErrorModel() {
    this.productErrors = [];
    this.resourceFrameErrors = [];
    this.productModel.nestedFrames.forEach((el, i) => {
      this.nestedFrameErrors.push([]);
    })
  }
  checkModelErrors() {
    this.checkPproductAttrError();
    this.checkResourceFrameError();
    this.checkNestedFrameError();
  }
  checkPproductAttrError() {
    this.productErrors = this.productModel.productAttributes.filter(x => x.isError && x.show);

  }
  checkResourceFrameError() {
    this.resourceFrameErrors = this.productModel.resourceFrame.attributeFilters.filter(x => x.isError && x.show);
  }
  checkNestedFrameError() {
    this.nestedFrameErrors = [];
    this.productModel.nestedFrames.forEach((nf, i) => {
      let errors = nf.attributeFilters.filter(x => x.isError && x.show);
      this.nestedFrameErrors.push(errors);
    });
    //console.log(n)
  }

  decryptV6ErrorMessage() {

    const t = 'For Door 2 - !!!WARNING!!! Lock Operator(s) must be specified with the selected lock (Interior or Exterior)["Lock","ExtLckOp","IntLckOp"]';
  }
  highlightFieldsWithError(key: string, frameId: number) {
    let field = this.productModel.productAttributes.find(x => x.v6ReferenceCode === key);
    if (field) { field.isError = true; return; }
    field = this.productModel.resourceFrame.attributeFilters.find(x => x.v6ReferenceCode === key);
    if (field) { field.isError = true; return; }

  }
  //#endregion
  outputToParent(quoteItemCommonId) {
    this.outputResponse.emit(quoteItemCommonId);
  }

  test() {
    //return;
    ////////only for test reg start   
    ////const resp = std_1dr_do;//test
    ////if (resp) {
    ////  this.productModel.quoteCommonId = resp.configuration.quoteCommonId;
    ////  this.productModel.quoteItemCommonId = resp.configuration.quoteItemCommonId;
    ////  if (this.v6productService.hasError(resp)) {
    ////    let destination = this.v6productService.bp1PreviewModel;
    ////    this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
    ////    this.outputToParent(resp.configuration.quoteItemCommonId);
    ////    if (resp.messages && resp.messages.length > 0) {
    ////      resp.messages.forEach((el, i) => {
    ////        if (el.type && el.type === 2) { this.productModel.erros.push(el.value); }
    ////      });
    ////    }
    ////    this.productModel.v6SummaryMessage = [];
    ////  }
    ////  else {
    ////    this.v6productService.bp2PreviewModel = cloneDeep(this.v6productService.bp1PreviewModel);
    ////    let destination = this.v6productService.bp2PreviewModel;
    ////    this.v6productService.mapCreateConfigRequestToProductModel(resp, destination);
    ////    this.outputToParent(resp.configuration.quoteItemCommonId);

    ////    this.v6productService.currentProductConfigStep = ProductConfigStep.CONFIG_DETAILS;
    ////  }
    ////}
    ////else {
    ////  //something happend
    ////  this.configError = 'Sorry an error occured. Please try again. If error persists then please contact Kawneer Helpdesk';
    ////}
    ////this.configCreationInProgres = false;

    //only for test reg end
  }


  selectedTab: any = 0;
  public onTabSelect(e: any) {
    console.log(e);
    this.productModel.resourceFrame.clicked = true;
  }
  onNestedFrameTabSelect(event, index) {
    this.productModel.nestedFrames[index].clicked = true;
  }
}
